{
  "version": 2,
  "name": "Apostle Islands",
  "displayInfo": {
    "description": "A cluster of forested islands on the south shore of Lake Superior. Shifty winds in the channels and long fetches out in open water.",
    "difficulty": "intermediate"
  },
  "region": {
    "dataSource": {
      "type": "usace-s3",
      "baseUrl": "https://noaa-nos-coastal-lidar-pds.s3.us-east-1.amazonaws.com/dem/USACE_Superior_DEM_2019_9185/",
      "statePrefix": "wi/",
      "urlList": "urllist9185.txt"
    },
    "bbox": {
      "minLat": 46.85,
      "minLon": -90.9,
      "maxLat": 47.05,
      "maxLon": -90.2
    },
    "interval": 100,
    "simplify": 100,
    "scale": 1,
    "minPerimeter": 1500,
    "minPoints": 4,
    "flipY": true
  },
  "waves": {
    "sources": [
      {
        "amplitude": 0.5,
        "wavelength": 48,
        "direction": 0.0,
        "phaseOffset": 0.0
      },
      {
        "amplitude": 0.22,
        "wavelength": 14,
        "direction": 0.05,
        "phaseOffset": 1.62
      },
      {
        "amplitude": 0.3,
        "wavelength": 55,
        "direction": -0.79,
        "phaseOffset": 3.24
      },
      {
        "amplitude": 0.3,
        "wavelength": 100,
        "direction": 2.36,
        "phaseOffset": 4.85
      },
      {
        "amplitude": 0.12,
        "wavelength": 18,
        "direction": -0.75,
        "phaseOffset": 0.19
      },
      {
        "amplitude": 0.07,
        "wavelength": 6,
        "direction": 0.1,
        "phaseOffset": 1.81
      }
    ]
  },
  "wind": {
    "sources": [
      {
        "direction": 0.0
      }
    ]
  },
  "startPosition": [-68000, 0],
  "trees": {
    "spacing": 35,
    "density": 0.75,
    "minElevation": 4,
    "maxElevation": 500
  }
}
